export default __webpack_public_path__ + "static/media/TICKET.ea4a2c41.png";